import { AutogenLayoutlayout_dimuxref } from "./autogen/AutogenLayoutlayout_dimuxref";
import {  Layout, TableRowDisplayEvent, Textbox,  FocusEvent,  ClickEvent } from "@mcleod/components";
import { SlideoutDecorator } from "@mcleod/components";
import { layout_dimuident } from "./layout_dimuident";

export class layout_dimuxref extends AutogenLayoutlayout_dimuxref {

/** This is an event handler for the onRowDisplay event of tblMobileUserXref. */
  tblMobileUserXrefOnRowDisplay(event: TableRowDisplayEvent) {
    const txtbox = event.getTableRow().findComponentById("textboxDimuxIdent") as Textbox;
    const ident: any = txtbox.text
    const txtDesc = event.getTableRow().findComponentById("textboxDimuxDesc") as Textbox;
    txtDesc.text = "";

    for( let i = 0; i < this.sourceDimuidents.rowCount; i++ )
    {
      this.sourceDimuidents.rowIndex = i;
      const row: any = this.sourceDimuidents.activeRow.data;
      if( row.dimui_ident == ident )
      {
         txtDesc.text = row.dimui_desc;
         //break;
      }
    }
  }


/** This is an event handler for the onClick event of buttonButton1. */
  buttonButton1OnClick(event: ClickEvent) {
    const layout = Layout.getLayout( "imaging/AccessAdmin/layout_dimuident" ) as layout_dimuident;
    new SlideoutDecorator({
        layout: layout,
        width: window.innerWidth * .40,
        height: window.innerHeight * .60,
        fillVerticalSpace: false,
        displayOverlay: true,
        overlayProps: { greyedBackground: true },
        title: "Mobile Identifiers",
        layoutLoadListeners: () => {
            layout.sourceDimuidents.search( { } );
        },
      });
  }
}
